import { Route, Routes } from "react-router-dom";
import Sidebar from "./_components/Sidebar";
import InfoLayout from "components/InfoLayout";
import MainPage from "views/current-workspace/MainPage";

const HEADER_MAP = {
  "/": {
    title: "Current Workspace Settings",
    subtitle: "Manage your current workspace.",
  },
};

const getWorkspaceKey = (location: Location): string => {
  const path = location.pathname.replace(/\/+$/, "").split("/").pop() || "";
  return path === "" ? "/" : `/${path}`;
};

const CurrentWorkspaceInfo = () => {
  return (
    <InfoLayout
      Sidebar={Sidebar}
      headerMap={HEADER_MAP}
      getHeaderKey={getWorkspaceKey}
    >
      <Routes>
        <Route path="/" element={<MainPage />} />
      </Routes>
    </InfoLayout>
  );
};

export default CurrentWorkspaceInfo;
